<template>
    <div class="page loginRegisterWrapper">
        <div class="image">
            <img src="@/assets/images/M3/logo-smis-gri.svg" alt="" class="login-mobile-logo">
            <LoginRegisterBG class="register"></LoginRegisterBG>
        </div>
        <b-overlay :show="registerLoading" class="date-user">
            <div>
                <RegisterForm @registerStarted="registerLoading = true" @registerEnded="registerLoading = false"></RegisterForm>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import RegisterForm from "./componenets/RegisterForm";
    import LoginRegisterBG from "./componenets/LoginRegisterBG";
    import {BOverlay} from 'bootstrap-vue';
    export default {
        name: "Test",
        components: {
            RegisterForm,
            LoginRegisterBG,
            BOverlay
        },
        props: {},
        data() {
            return {
                registerLoading: false
            };
        },
        created() {},
        methods: {},
    };
</script>

<style scoped>
	.page {
		width: 100%;
		display: flex;
        background-color: #fff;
        height: auto;
	}
    .date-user{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
	.image {
		width: 73%;
		display: flex;
		flex-direction: column;
		align-self: center;
	}
	.loginRegisterWrapper {
		position: relative;
	}
     @media (max-width:1023px) and (min-width:820px) {
       .image {
         width: 63%;
       }
     }
    @media (max-width: 1281px){

        .image{
            width: 100%;
        }
        .date-user{
            bottom: 0;
            background: transparent;
        }

    }
    @media screen and (max-width: 1080px) and (orientation: landscape){
        .loginRegisterWrapper .date-user label {
            font-size: 13px;
        }
        .loginRegisterWrapper .first-text {
            font-size: 17px!important;
        }
        .loginRegisterWrapper .second-text {
            font-size: 13px;
        }
        .loginRegisterWrapper .custom-control-label {
            font-size: 10px!important;
            margin-bottom: 10px;
        }
    }
    @media (max-width: 841px) {
        body {
            height: max-content;
        }
      .page.contentPage{
          flex-direction: column;
      }
    }
    @media screen and (max-width: 841px) and (orientation: landscape) {
        .page{
            height: max-content;
        }
    }
    @media (max-width:500px) {
        .leftNavWrapper .header-container, body{
            overflow: visible;
        }
        .contentPage{
            overflow-x: visible;
        }
        .page{
            display: block;
            height: max-content;
            min-height: 100vh;

        }
        .date-user{
            width: 100%;
            padding: 0.4rem 0;
        }
    }
    @media screen and (max-width: 500px) and (orientation: landscape) {
        .page{
            height: max-content;
        }
    }
</style>
